module.exports = __webpack_public_path__ + "media/site_templates/www.tv-installation.com.au/images/our_services_1-37a18e942b0ee68c5393b0f65757f313.jpg";